import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getServicesData } from "../../utils/home-util";

export const getServicesDatareq = createAsyncThunk(
  "getServicesDatareq",
  async (res) => {
      const responce = await getServicesData(res);
    return responce.data;
  }
);

const servicesSlice = createSlice({
  name: "services",
  initialState: {
    servicesPageData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getServicesDatareq.fulfilled, (state, action) => {
      state.loading = false;
      state.servicesPageData = action.payload;
      state.error = null;
    });
    builder.addCase(getServicesDatareq.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getServicesDatareq.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {} = servicesSlice.actions;
export default servicesSlice.reducer;
